import React, {memo} from 'react';

import SaleElement from './sale-element'

const Sales = memo(({salesdata, onChangeSale}) => {

	const elements = salesdata.map( (item, id) => {
		const {...itemProps} = item;
		return (
			<React.Fragment key={id}>
				<SaleElement
					{...itemProps}
					id = {id}
					onChangeSale = {onChangeSale}
				/>
			</React.Fragment>
		)
	});

	return (
		<div className="wincalc-sales wincalc-widget">
			<div className="wincalc-box">
				{elements}
			</div>
		</div>
	)
})

export default Sales;